import contacts from './contacts';

export default function*() {
    yield* [...contacts];
}
